import React from "react";
import PropTypes from "prop-types";
import produce from "immer";
import map from "lodash/map";
import TextBox from "components/common/TextBox";


export default function AssignPointValues(props) {
	const {
		data = [],
		onChange,
	} = props;
	
	const handleUpdate = (product, index, name, value) => {
		const multipliers = produce(data, draft => {
			draft[index][name] = value ? Number(value) : null;
		});
		onChange({
			name: "Multipliers",
			value: multipliers,
		});
	}

    return (
		<div>
			<h3>Assign Point Values</h3>
			<hr />
			{data?.length ? (
		        <table className="table">
			        <tbody>
				        {map(data, (product, index) => (
					        <tr key={product.ProductBrandId}>
						        <td className="no-wrap">{product.ProductBrandName}</td>
						        <td>1 Dose</td>
						        <td><i className="fa fa-equals"/></td>
						        <td>
							        <TextBox
								        name="Multiplier"
								        onChange={({ name, value }) => handleUpdate(product, index, name, value)}
								        required
								        value={product.Multiplier}
							        />
								</td>
						        <td>Point(s)</td>
					        </tr>
				        ))}
			        </tbody>
		        </table>
			) : (
				<div>Select products to set point values</div>
			)}
		</div>
    );
}

AssignPointValues.propTypes = {
	clinicId: PropTypes.number,
    clinicProducts: PropTypes.array,
    productIds: PropTypes.arrayOf(PropTypes.number),
}
